import colorPattern from '../../../DesignSystem/colors'

const darkSurfaceColors = {
    'background-primary': colorPattern.onyx,
    'background-secondary': colorPattern.smoke,
    'background-invert': colorPattern.pearl,
    'background-brand-primary': colorPattern.cyan,
    'background-brand-secondary': colorPattern.purple,
    'background-tertiary': colorPattern.onyx,
} as const

export default darkSurfaceColors
